import React from 'react'

interface Props {
  width?: string
  height?: string
  fill?: string
}

const IconDevice = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24">
      <g>
        <rect x="4" y="4" width="16" height="12" fill={fill} opacity={0.3} rx="2" />
        <path fill={fill} d="M8 20h8v-2H8v2Z" />
      </g>
    </svg>
  )
}

export default IconDevice